import React, { useEffect } from "react";
import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import BannerTableComponent from "../../../components/admin/banner-manager/BannerTable";
import { BannerAddDrawer } from "../../../components/admin/banner-manager/BannerAddDrawer";
import { SearchRecords } from "../../../components/Common/SearchRecords";
import { useGetBannerListQuery } from "../../../store/masters/mastersApis";
import { Add } from "@mui/icons-material";

const BannerManagerContainer = (props) => {
    const { showDrawer, formType, bannerInitialValue, pagination } = props;
    const { isLoading, data: gallery, isFetching } = useGetBannerListQuery(pagination);

    const handleAddBanner = () => {
        props.changeBannerInitialState({
            showDrawer: true,
            formType: "Add"
        })
    }

    useEffect(() => {
        props.handlePaginationState({
            pageNo: 0,
            limit: 10,
            sortBy: -1,
            sortField: "createdAt",
            keywords: ""
        })
    }, []);

    const handlePagination = (setting) => {
        props.handlePaginationState(setting);
    }

    const handleDrawerClose = () => {
        props.changeBannerInitialState({ showDrawer: false, formType: "", bannerInitialValue: {} })
    }

    const handleBannerEdit = (data, type) => {
        let payload = { ...data };
        delete payload.createdAt;
        props.changeBannerInitialState({ showDrawer: true, formType: type, bannerInitialValue: payload })
    }

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between">
                    <Grid item sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">List of Banner</Typography>
                    </Grid>
                    <Grid item>
                        <Button
                            disableElevation
                            variant="contained"
                            sx={{ borderRadius: "50px" }}
                            onClick={() => handleAddBanner()}
                            startIcon={<Add />}
                        >
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container>
                <SearchRecords handlePagination={handlePagination} pagination={pagination} />
                <Grid item xs={12}>
                    <Paper
                        sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                        elevation={0}
                    >
                        <BannerTableComponent fetching={isFetching} edit={(val, type) => handleBannerEdit(val, type)} loading={isLoading} count={gallery?.count || 0} data={gallery?.result || []} pagination={pagination} handlePagination={(val) => handlePagination(val)} />
                    </Paper>
                </Grid>
            </Grid>

            {/* add taf drawer */}
            <BannerAddDrawer getSansthaList={props.getSansthaList} show={showDrawer} close={handleDrawerClose} formType={formType} bannerInitialValue={bannerInitialValue} />

        </Stack >
    );
}

export default BannerManagerContainer;